"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegionCodeFromLocale = void 0;
var replace_1 = __importDefault(require("lodash/fp/replace"));
/**
* @example
* getRegionCodeFromLocale('en-US' }) // US
* */
var getRegionCodeFromLocale = function (locale) {
    if (locale === void 0) { locale = ''; }
    try {
        var normalizedLocale = (0, replace_1.default)('_', '-')(locale);
        if (normalizedLocale) {
            return (new Intl.Locale(normalizedLocale)).region;
        }
        return '';
    }
    catch (error) {
        return '';
    }
};
exports.getRegionCodeFromLocale = getRegionCodeFromLocale;
exports.default = exports.getRegionCodeFromLocale;
